/* Depozit: event names only. Uses the existing Clarity integration and its consent handling. */
(function (window, document) {
  'use strict';

  if (window.__ddcClarityEventsInstalled) return;
  window.__ddcClarityEventsInstalled = true;

  var cartVisitOpen = false;

  function record(name) {
    // Do not create a loader, consent override, identifier or replay queue.
    if (typeof window.clarity !== 'function') return false;
    try {
      window.clarity('event', name);
      return true;
    } catch (error) {
      // Analytics must never interrupt shopping.
      return false;
    }
  }

  function isCartPage() {
    return /^\/cart\/?$/.test(window.location.pathname);
  }

  function recordCartVisit() {
    if (!isCartPage() || cartVisitOpen) return;
    cartVisitOpen = record('ddc_cart_page_view');
  }

  document.addEventListener('cart:update', function (event) {
    var data = event.detail && event.detail.data;
    // This theme also uses cart:update for failed adds and cart quantity edits.
    if (!data || data.source !== 'product-form-component' || data.didError) return;
    if (typeof data.itemCount !== 'number' || !isFinite(data.itemCount) || data.itemCount <= 0) return;
    record('ddc_add_to_cart_success');
  });

  function isBlocked(element) {
    var node = element;
    if (!node) return true;
    if (node.disabled) return true;
    if (typeof node.matches === 'function' && node.matches(':disabled')) return true;
    while (node && node.getAttribute) {
      if (node.getAttribute('aria-disabled') === 'true' || node.hasAttribute('inert')) return true;
      node = node.parentElement;
    }
    return false;
  }

  window.addEventListener('submit', function (event) {
    var form = event.target;
    var button = event.submitter;
    var tag = button && button.tagName;
    var finished = false;
    var timer;

    // Require the native cart form's actual checkout submitter, including keyboard activation.
    // Missing submitter, direct form.submit(), and accelerated checkout are not inferred.
    if (!isCartPage() || !form || form.tagName !== 'FORM' || form.id !== 'cart-form') return;
    if (!button || button.form !== form || button.name !== 'checkout') return;
    if ((tag !== 'BUTTON' && tag !== 'INPUT') || button.type !== 'submit') return;
    if (isBlocked(button) || isBlocked(form)) return;

    function finish() {
      if (finished) return;
      finished = true;
      window.clearTimeout(timer);
      window.removeEventListener('pagehide', finish);
      // Check after all synchronous handlers, including minimum-order validation.
      if (!event.defaultPrevented) record('ddc_checkout_click');
    }

    // Do not delay, cancel or rewrite the checkout. pagehide is a best-effort fallback
    // when navigation happens before this timer. The event means intent, not arrival.
    window.addEventListener('pagehide', finish);
    timer = window.setTimeout(finish, 0);
  }, true);

  window.addEventListener('pagehide', function () {
    cartVisitOpen = false;
  });
  window.addEventListener('pageshow', recordCartVisit);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', recordCartVisit);
  } else {
    recordCartVisit();
  }
})(window, document);
